'use client';

import { useTranslation } from 'react-i18next';

import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import { useSupporterAccount } from '@sola/supporter-sdk/hooks/settings.ts';

import {
  AccountEmailPhone,
  AccountInformation,
  AccountMailingAddress,
  AccountProfile,
  AccountUsernamePassword,
  SettingDivider,
} from '../../molecules/account-settings-section/account-settings-section.tsx';
import { LocalAlertsProvider } from '../../molecules/local-alerts/local-alerts-provider.tsx';
import { LocalAlerts } from '../../molecules/local-alerts/local-alerts.tsx';
import { AccountSettingsSkeleton } from './account-settings-skeleton.tsx';

export const AccountSettings = () => {
  const {
    supporter,
    supporterAddress,
    preferredUsername,
    contacts,
    showSkeleton,
  } = useSupporterAccount();
  const { t } = useTranslation('my-settings');
  const hasSupporter = !!supporter;
  const hasAddress = !!supporterAddress;

  return (
    <div className="max-w-md">
      {!showSkeleton && hasSupporter && hasAddress && (
        <LocalAlertsProvider>
          <LocalAlerts />
          <AccountInformation supporter={supporter} />
          <SettingDivider />
          <AccountProfile supporter={supporter} />
          {/* TODO: Should show an error message in the section if we cannot retrieve username */}
          {preferredUsername && (
            <>
              <SettingDivider />
              <AccountUsernamePassword username={preferredUsername} />
            </>
          )}
          <SettingDivider />
          <AccountMailingAddress addressDetails={supporterAddress} />
          <SettingDivider />
          <AccountEmailPhone supporter={supporter} />
          {contacts && contacts.length > 0 && (
            <Alert
              variant="neutral"
              title={t('my-settings:account.associate', {
                count: contacts.length,
              })}
              message={t('my-settings:account.supportText')}
              action={
                <a href="/" target="_blank" rel="noreferrer">
                  {t('my-settings:account.contactLink')}
                </a>
              }
            />
          )}
        </LocalAlertsProvider>
      )}
      {showSkeleton && <AccountSettingsSkeleton />}
    </div>
  );
};
